/** Clamp a value into [min, max]. */
export function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}

/** Clamp a value into [0, 1]. */
export function clamp01(value: number): number {
  return clamp(value, 0, 1);
}

/** Linear interpolation between a and b by t in [0, 1]. */
export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * clamp01(t);
}

/**
 * Frame-rate independent exponential smoothing.
 * Moves `current` towards `target`, covering half the remaining distance
 * every `halfLifeSeconds`, regardless of frame duration.
 */
export function expSmooth(
  current: number,
  target: number,
  deltaSeconds: number,
  halfLifeSeconds: number,
): number {
  if (halfLifeSeconds <= 0) {
    return target;
  }
  const factor = 1 - Math.pow(2, -deltaSeconds / halfLifeSeconds);
  return current + (target - current) * factor;
}
